import type { ReactElement } from 'react';

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Button } from '@/components/ui/button';

interface DisconnectSlackDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  readOnly?: boolean;
}

export function DisconnectSlackDialog({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  readOnly,
}: DisconnectSlackDialogProps): ReactElement {
  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Disconnect Slack notifications?</AlertDialogTitle>
          <AlertDialogDescription>
            Are you sure you want to delete these Slack notification settings?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>
            Keep settings
          </AlertDialogCancel>
          <Button
            onClick={onConfirm}
            disabled={isLoading || (readOnly ?? false)}
            variant="destructive"
          >
            {isLoading ? 'Deleting...' : 'Delete settings'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

DisconnectSlackDialog.displayName = 'DisconnectSlackDialog';
